export const en = {
  updatePaymentDetails: 'Update Payment Details',
  pauseSubscription: (price: number) => `Pause Subscription ($${price} p/m)`,
  cancelSubscription: 'Cancel Subscription',
  reactivateSubscription: 'Reactivate Subscription'
};

export type Translations = typeof en;
